exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topDiv {\n  padding-top: 20px;\n  background: whitesmoke;\n  height: 100vh; }\n\n.bg-blue {\n  background-color: #00c0ef !important; }\n\n.bg-green {\n  background-color: #00a65a !important; }\n\n.bg-orange {\n  background-color: #f39c12 !important; }\n\n.bg-red {\n  background-color: #d9534f !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/device-inventory/device-inventory.component.scss
// module id = ../../../../../src/app/device-inventory/device-inventory.component.scss
// module chunks = main